<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="customerInfo">
            <van-nav-bar
                title="客户信息"
                left-text="合同详情"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <div class="header">
                <div class="headPortrait van_left">
                    <img src="@/assets/images/addressBook/default.png" alt="头像">
                    <i>企业用户</i>
                </div>
                <div class="info van_left">
                    <p>中国建筑第八工程局有限公司</p>
                    <div>
                        <van-rate
                            v-model="value"
                            :allow-half="true"
                            :readonly="true"
                            :size="12"
                        ></van-rate>
                        <span>企业风险(暂无)</span>
                    </div>
                </div>
            </div>
            <section>
                <div class="basicInfo">
                    <van-cell
                        value="中铁十二局集团有限公司"
                        title="客户名称"
                        :icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-cell>
                    <van-cell
                        value="9XXXXXXXXXXXXXX0Y"
                        title="统一信用代码"
                        :icon="require('@/assets/images/icons/icon_33.png')"
                    ></van-cell>
                    <van-cell
                        value="企业用户"
                        title="客户类型"
                        :icon="require('@/assets/images/icons/icon_gy_5.png')"
                    ></van-cell>
                    <van-cell
                        title="客户资信"
                        :icon="require('@/assets/images/icons/icon_40.png')"
                    >
                        <van-rate
                            v-model="value"
                            :allow-half="true"
                            :readonly="true"
                        ></van-rate>
                    </van-cell>
                    <van-cell
                        value="1000000000"
                        title="注册资本金"
                        :icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-cell>
                    <van-cell
                        value="1989-11-11"
                        title="成立时间"
                        :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-cell>
                    <van-cell
                        value="暂无"
                        title="企业风险"
                        :icon="require('@/assets/images/icons/icon_41.png')"
                    ></van-cell>
                    <van-cell
                        value="这个客户最近回款不错"
                        title="备注"
                        :icon="require('@/assets/images/icons/icon_gy_4.png')"
                    ></van-cell>
                </div>
                <div class="evaluationInfo">
                    <van-cell
                        value="良好"
                        title="回款能力评分"
                        :icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-cell>
                    <van-cell
                        value="良好"
                        title="供应方量评分"
                        :icon="require('@/assets/images/icons/icon_30.png')"
                    ></van-cell>
                    <van-cell
                        value="良好"
                        title="销售价格评分"
                        :icon="require('@/assets/images/icons/icon_42.png')"
                    ></van-cell>
                    <van-cell
                        value="良好"
                        title="服务过程评分"
                        :icon="require('@/assets/images/icons/icon_43.png')"
                    ></van-cell>
                    <van-cell
                        value="良好"
                        title="账龄情况评分"
                        :icon="require('@/assets/images/icons/icon_26.png')"
                    ></van-cell>
                </div>
                <dl>
                    <dt class="iconfont iconpinjiantixi">
                        以往项目
                    </dt>
                    <dd class="engineeringInfo">
                        <h4>
                            <span>北京大兴国际机场</span>
                        </h4>
                        <p>
                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                            <span>工程位置：北京市大兴区188号</span>
                        </p>
                        <p>
                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                            <span>业务员：王宝宝</span>
                        </p>
                        <span class="state iconfont iconjiaobiao"><i>零售</i></span>
                        <button class="telephone" @click.stop="openContactInfo()"></button>
                    </dd>
                </dl>
            </section>
            <van-action-sheet
                v-model="actionSheetShow"
                cancel-text="取消"
                class="contactInfo"
            >
                <h5>aaa</h5>
                <p>联系电话：111</p>
            </van-action-sheet>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 客户信息
    name: 'customer-info',
    components: {},
    props: {},
    data() {
        return {
            value: 3.5,
            // 联系人上拉菜单状态
            actionSheetShow: false,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开联系人信息上拉菜单
        openContactInfo(data) {
            this.contactInfo = data;
            this.actionSheetShow = true;
        },
    },
};
</script>
<style lang="stylus">
.customerInfo
    height 100%
    .header
        height 100rpx
        background #101077
        padding 18rpx
        .headPortrait
            text-align center
            width 52rpx
            position relative
            margin-right 18rpx
            img
                width 50rpx
                height 50rpx
            i
                position absolute
                width 52rpx
                height 17rpx
                background url(./../../../assets/images/contractInfo/bg_customer@2x.png) no-repeat
                background-size 100%
                font-size 10rpx
                line-height 17rpx
                text-align center
                color #fff
                left 0
                bottom 0
        .info
            p
                font-size 16rpx
                line-height 30rpx
                color #FFFFFF
            .van-rate, span
                float left
            .van-rate
                margin 4rpx 0
            span
                font-size 12rpx
                line-height 20rpx
                margin-left 15rpx
                color #fff
    section
        height calc(100% - 145rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .basicInfo
            border-bottom 15rpx solid #F0F0F0
        dl
            background #F0F0F0
            padding 15rpx
            dt
                font-size 18rpx
                color #3495FB
                margin-bottom 15rpx
            .engineeringInfo
                background #fff
                height 126rpx
                position relative
                img,span
                    float left
                    height 16rpx
                    line-height 16rpx
                img
                    width 16rpx
                    margin-right 12rpx
                h4,p
                    overflow hidden
                h4
                    margin-bottom 14rpx
                    padding 15rpx
                    border-bottom 2px solid #F0F0F0
                    span
                        font-size 18rpx
                        height 20rpx
                        line-height 20rpx
                        color #061F3E
                        &:before
                            font-size 20rpx
                            margin-right 10rpx
                            color #FF6600
                p
                    margin-bottom 14rpx
                    padding 0 15rpx
                    span
                        display inline-block
                        width calc(100% - 40rpx)
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        font-size 14rpx
                        color #666666
                .state
                    position absolute
                    top 0
                    right 0
                    font-weight 400
                    width 40rpx
                    height 40rpx
                    &:before
                        font-size 40rpx
                        line-height 40rpx
                        color #FF6600
                        position absolute
                        top 0px
                        right 0
                    i
                        position absolute
                        width 40rpx
                        text-align center
                        font-size 12rpx
                        color #FFFFFF
                        transform rotate(45deg)
                        top 7rpx
                        left 7rpx

                .telephone
                    width 25rpx
                    height 25rpx
                    background url(./../../../assets/images/clueManagement/phone@2x.png)
                    background-size 100% 100%
                    border none
                    position absolute
                    right 15rpx
                    bottom 12rpx
    .van-icon
        .van-icon__image
            width 16rpx
            height 16rpx
            margin-top 3rpx
            margin-right 5rpx
    .van-collapse
        &:after
            display none
    .van-cell__title
        width 100rpx
        font-size 18rpx
        line-height 24rpx
        color #061F3E
        .iconfont
            font-size 18rpx
            margin-right 5rpx
    .van-collapse-item__content
        .van-cell__title
            font-size 16rpx
    .title
        font-size 17rpx
        color #3495FB
    .van-collapse-item__content
        padding 0
    .van-field__control,
    .van-cell__value
        color #979EA7
        &::placeholder
            color #D7D7D7 !important
    .contactInfo
        h5,p
            font-size 16rpx
            line-height 45rpx
            text-align center
        h5
            color #333333
            background #F8F8F8
        p
            color #0189FC
            border-bottom 1px solid  #F0F0F0
</style>